import { create } from 'zustand';

import { APP_CONST } from '@/constant';
import i18n from '@/i18n';
import { storage } from '@/package';

const STORED_LANG =
  storage.local.get<APP_CONST.LANG | string>(APP_CONST.KEYS.STORAGE_LANG) ??
  APP_CONST.LANG.EN;

await i18n.changeLanguage(STORED_LANG);
storage.local.set(APP_CONST.KEYS.STORAGE_LANG, STORED_LANG);

const useLangStore = create<{
  language: APP_CONST.LANG | string;
  changeLanguage<T extends APP_CONST.LANG | string>(language: T): Promise<void>;
}>(set => ({
  language: STORED_LANG,

  changeLanguage<T extends APP_CONST.LANG | string>(language: T) {
    return i18n.changeLanguage(language).then(() => {
      storage.local.set(APP_CONST.KEYS.STORAGE_LANG, language);
      set(state => ({ ...state, language }));
    });
  },
}));

export default useLangStore;
